export default __webpack_public_path__ + "static/media/3.80e72fff.png";